export default __webpack_public_path__ + "static/media/td-search-icon.c9250003.svg";